module.exports = __webpack_public_path__ + "static/img/fullscreen-image_explore-your-options_en_768.14cd2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_explore-your-options_en_768.png
// module id = rpYB
// module chunks = 0